import React from "react";

const CircularButton = ({
  children,
  icon,
  text,
  isActive = false,
  onClick,
  className = "",
  size = "48px",
  disabled = false,
  ...props
}) => {
  const content = icon || text || children;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        rounded-[14px] flex items-center justify-center transition-colors focus:outline-none focus:ring-0 
        active:outline-none active:ring-0 disabled:opacity-50 disabled:cursor-not-allowed
        ${isActive ? "bg-[#2C2C3A] text-white" : "bg-[#2C2C3A] hover:bg-[#262635] text-gray-400"}
        ${className}
      `}
      style={{ width: size, height: size }}
      {...props}
    >
      {content}
    </button>
  );
};

export default CircularButton;
